<template>
  <div class="contact-panel">
    <div class="contact-panel__list">
      <div class="contact-panel__item">
        <span class="contact-panel__label">
          <span>{{ emailText }}</span>
        </span>
        <a class="contact-panel__button" :href="'mailto:' + email">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 80 47"
            width="40"
            height="40"
            fill="currentColor"
            stroke="none"
          >
            <path
              d="M16.51 44.44L8.83 44.44C8.15 44.44 7.6 45 7.6 45.68C7.6 46.36 8.15 46.91 8.83 46.91L16.51 46.91C17.19 46.91 17.74 46.36 17.74 45.68C17.74 45 17.19 44.44 16.51 44.44Z"
            />
            <path
              d="M16.57 37.91L1.12 37.91C0.44 37.91 -0.11 38.46 -0.11 39.14C-0.11 39.83 0.44 40.38 1.12 40.38L16.57 40.38C17.25 40.38 17.8 39.83 17.8 39.14C17.8 38.46 17.25 37.91 16.57 37.91Z"
            />
            <path
              d="M16.51 31.59L5.99 31.59C5.31 31.59 4.76 32.14 4.76 32.82C4.76 33.5 5.31 34.06 5.99 34.06L16.51 34.06C17.2 34.06 17.75 33.5 17.75 32.82C17.75 32.14 17.2 31.59 16.51 31.59Z"
            />
            <path
              d="M79.47 2.75L79.47 37.61C79.47 39.19 78.18 40.48 76.59 40.48L25.3 40.48C23.71 40.48 22.42 39.19 22.42 37.61L22.42 2.75C22.42 1.99 22.72 1.27 23.26 0.73C23.8 0.18 24.53 -0.12 25.3 -0.12L76.59 -0.12C77.18 -0.12 77.75 0.06 78.24 0.39C79.01 0.93 79.47 1.81 79.47 2.75ZM77.35 37.61L77.35 2.97L56.59 22.37C55.08 23.88 53.08 24.71 50.95 24.71C48.81 24.71 46.81 23.88 45.3 22.37L24.54 2.97L24.54 37.61C24.54 37.62 24.55 37.62 24.55 37.63L42.69 20.84L44.18 22.33L26.86 38.37L74.97 38.37L57.74 22.42L59.24 20.92L77.34 37.67C77.34 37.65 77.35 37.63 77.35 37.61ZM46.8 20.87C47.91 21.98 49.38 22.59 50.95 22.59C52.51 22.59 53.98 21.98 55.09 20.87L75.29 1.99L26.6 1.99L46.8 20.87Z"
            />
          </svg>
        </a>
      </div>
      <div class="contact-panel__item">
        <span class="contact-panel__label">
          <span>{{ telText }}</span>
        </span>
        <a class="contact-panel__button" :href="'tel:' + tel">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 56 79"
            width="40"
            height="40"
            fill="currentColor"
            stroke="none"
          >
            <path
              d="M19.21 8.31C19.3 8.5 19.35 8.72 19.34 8.94C19.32 9.69 18.69 10.28 17.94 10.26C15.82 10.2 13.85 11.11 12.53 12.76C11.21 14.41 10.76 16.53 11.29 18.58C11.47 19.31 11.04 20.06 10.31 20.24C9.58 20.43 8.84 20 8.65 19.27C7.9 16.38 8.54 13.38 10.4 11.06C12.26 8.73 15.04 7.45 18.02 7.54C18.55 7.55 19 7.87 19.21 8.31Z"
            />
            <path
              d="M16.9 0.92C16.98 1.07 17.02 1.25 17.03 1.43C17.08 2.18 16.5 2.82 15.75 2.87C12.04 3.08 8.59 4.86 6.27 7.76C3.95 10.66 2.98 14.42 3.59 18.08C3.72 18.83 3.22 19.53 2.47 19.65C1.73 19.78 1.03 19.28 0.9 18.54C0.16 14.11 1.34 9.56 4.14 6.05C6.94 2.55 11.12 0.4 15.6 0.14C16.16 0.11 16.67 0.43 16.9 0.92Z"
            />
            <path
              d="M38.3 72.15L33.49 72.15C32.74 72.15 32.13 71.54 32.13 70.78C32.13 70.03 32.74 69.42 33.49 69.42L38.3 69.42C39.06 69.42 39.67 70.03 39.67 70.78C39.67 71.54 39.06 72.15 38.3 72.15Z"
            />
            <path
              d="M55.94 62.63C55.94 62.74 55.93 62.85 55.92 62.96L55.94 62.96L55.94 72.65C55.94 76.05 53.19 78.8 49.79 78.8L22 78.8C18.61 78.8 15.86 76.05 15.86 72.65L15.86 20.41C15.86 16.87 18.73 13.99 22.27 13.99L49.53 13.99C53.07 13.99 55.94 16.87 55.94 20.41L55.94 62.63ZM53.21 65.69L18.58 65.69L18.58 72.65C18.58 74.54 20.12 76.07 22 76.07L49.79 76.07C51.68 76.07 53.21 74.54 53.21 72.65L53.21 65.69ZM18.58 62.68L53.16 62.68C53.19 62.68 53.22 62.66 53.22 62.63L53.22 20.41C53.22 18.37 51.56 16.72 49.53 16.72L22.27 16.72C20.24 16.72 18.58 18.37 18.58 20.41L18.58 62.68Z"
            />
          </svg>
        </a>
      </div>
      <div
        v-if="isScriptLoaded"
        class="contact-panel__item"
        :class="{ 'contact-panel__item--active': isChatOpen }"
      >
        <span class="contact-panel__label">
          <span>{{ chatText }}</span>
        </span>
        <span class="contact-panel__button" @click="toggleChat">
          <ag-icon icon="x" v-if="isChatOpen"></ag-icon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 194 172"
            width="40"
            height="40"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="8"
            v-else
          >
            <path
              d="M149.29 36.07L181.96 36.07C186.13 36.07 189.5 39.4 189.5 43.5L189.5 144.83C189.5 148.93 186.13 152.25 181.96 152.25L165 152.25L155.57 167.1L146.14 152.25L76.39 152.25C72.22 152.25 68.85 148.93 68.85 144.83L68.85 136.57"
            />
            <path
              d="M125.15 3.9L12.54 3.9C8.1 3.9 4.5 7.5 4.5 11.94L4.5 110.8C4.5 115.24 8.1 118.84 12.54 118.84L30.64 118.84L40.69 134.93L50.75 118.84L125.15 118.84C129.6 118.84 133.2 115.24 133.2 110.8L133.2 11.94C133.2 7.5 129.6 3.9 125.15 3.9Z"
            />
            <path
              d="M76.89 56.96C76.89 52.52 73.29 48.91 68.85 48.91C64.4 48.91 60.8 52.52 60.8 56.96C60.8 61.4 64.4 65 68.85 65C73.29 65 76.89 61.4 76.89 56.96Z"
            />
            <path
              d="M44.71 56.96C44.71 52.52 41.11 48.91 36.67 48.91C32.23 48.91 28.63 52.52 28.63 56.96C28.63 61.4 32.23 65 36.67 65C41.11 65 44.71 61.4 44.71 56.96Z"
            />
            <path
              d="M109.07 56.96C109.07 52.52 105.46 48.91 101.02 48.91C96.58 48.91 92.98 52.52 92.98 56.96C92.98 61.4 96.58 65 101.02 65C105.46 65 109.07 61.4 109.07 56.96Z"
            />
          </svg>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import { defineComponent, ref } from '@vue/composition-api'

  export default defineComponent({
    props: {
      emailText: {
        type: String,
        required: true,
      },
      telText: {
        type: String,
        required: true,
      },
      chatText: {
        type: String,
        required: true,
      },
      email: {
        type: String,
        required: true,
      },
      tel: {
        type: String,
        required: true,
      },
    },
    setup() {
      const isScriptLoaded = ref(false)
      const isChatOpen = ref(false)

      window.onSIApiReady = () => {
        isScriptLoaded.value = true

        console.log(isScriptLoaded.value)

        window.SI_API.onChatOpened = () => {
          isChatOpen.value = true
        }

        window.SI_API.onChatClosed = () => {
          isChatOpen.value = false
        }
      }

      const toggleChat = () => {
        if (!isScriptLoaded.value) {
          return
        }

        if (isChatOpen.value) {
          window.SI_API.hidePopup(settings)
          isChatOpen.value = false
        } else {
          window.SI_API.showPopup(settings)
          isChatOpen.value = true
        }
      }

      return {
        toggleChat,
        isChatOpen,
        isScriptLoaded,
      }
    },
  })
</script>
